// extracted by mini-css-extract-plugin
export default {"main":"styles_main__v6Wdm","alpha_list":"styles_alpha_list__Xz0Ss"};